import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { API } from '../../shared/api.constants';
import { map } from 'rxjs/operators';
import { ResponseWrapper } from '../../shared';


@Injectable()
export class LoginService {

	dataa: any;
	private resourceUrlLogin = API.host + 'session/client-login';
    private resourceUrlGetFooterInfo = API.host + 'InvoicePortal/portal-get-footer-info';
	private resourceUrlSetCaptchaSession = API.host + 'session/set-captcha-session';

	constructor(private http: HttpClient) { }

	SVLogin(UserName: string, Pass: string, Captcha: string) {
		const httpOptions = {

			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		var loginuser = {
			userId: UserName,
			password: Pass,
			captcha: Captcha
		}

		return this.http.post(`${this.resourceUrlLogin}`, loginuser, httpOptions)
			.pipe(map(
				(res: HttpResponse<any>) => {
					return res
				}))
			;
	}

	getFooterInfo(): Observable<ResponseWrapper> {
        return this.http.get(this.resourceUrlGetFooterInfo)
            .map((res: HttpResponse<any>) => this.convertResponse(res));
	}
	
	private convertResponse(res: any): any {
        if (!res ) {
            throw 'Invalid Code';
        }

        // const jsonResponse = res.json().data;
        return res.data;
    }

	SetCaptchaSession(captcha: string): Observable<any> {
        return this.http.get(`${this.resourceUrlSetCaptchaSession}/${captcha}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

}
